import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './ui/CtaButton';
import { OFFER_ANCHOR, PACK_IMAGE, PRODUCT_NAME } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <header className="border-b-4 border-coral bg-surface" data-id="element-92" data-mp="9lbg511q9bdl">
      <p className="bg-primary px-3 py-1.5 text-center font-sub text-sm font-semibold leading-tight text-white sm:text-base" data-id="element-93" data-mp="4m8l89fgoljc">
        Método de aprendizaje visual paso a paso
      </p>

      <div className="mx-auto max-w-2xl px-3 pb-4 pt-3 text-center sm:px-5" data-id="element-94" data-mp="xanojyp8dfeu">
        <motion.h1 initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE
      }} className="font-display text-[1.6rem] font-extrabold leading-[1.1] tracking-tight text-ink sm:text-4xl" data-id="element-95" data-mp="x8jndoipuui9">
          El sistema completo para{' '}
          <span className="text-primary" data-id="element-96" data-mp="382p6pg8rpjmq">estudiar enfermería</span> con{' '}
          <span className="bg-blush px-1 text-coral" data-id="element-97" data-mp="384s6grzq2r4n">más de 250 mapas visuales</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.05
      }} className="mx-auto mt-2 max-w-xl text-sm leading-snug text-muted" data-id="element-98" data-mp="3j6oe7qokeyt9">
          Comprende anatomía, patologías, farmacología, procedimientos y
          urgencias con material organizado para estudiar, repasar y prepararte
          para tus evaluaciones,{' '}
          <strong className="font-semibold text-ink" data-id="element-99" data-mp="359t0hkxdcj6v">
            sin perderte entre apuntes interminables, conceptos difíciles y
            cientos de páginas.
          </strong>
        </motion.p>

        <p className="mt-2 inline-block rounded-lg bg-ink px-3 py-1.5 font-display text-xs font-extrabold uppercase leading-tight tracking-wide text-white sm:text-sm" data-id="element-100" data-mp="2vjzqgocvkc4q">
          {PRODUCT_NAME} · <span className="text-tint" data-id="element-101" data-mp="2ll0eowwtc0di">6 Tomos + 5 Bonos</span>
        </p>

        <motion.a href={OFFER_ANCHOR} initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.1
      }} className="mt-2 block overflow-hidden rounded-2xl border-4 border-primary bg-tint" data-id="element-102" data-mp="s21iocxnug0i">
          <img src={PACK_IMAGE} alt={`${PRODUCT_NAME}: 6 tomos digitales con 270 mapas visuales y 5 bonos incluidos`} className="block w-full" data-id="element-103" data-mp="ddf4iejrruav" />
        </motion.a>

        <p className="mt-1.5 font-sub text-xs font-semibold leading-snug text-muted sm:text-sm" data-id="element-104" data-mp="161b0fh1ili6l">
          {PRODUCT_NAME}: 6 tomos digitales con 270 mapas visuales y 5 bonos
          incluidos.
        </p>

        <div className="mt-2.5" data-id="element-105" data-mp="x1w7maxvkvix">
          <CtaButton href={OFFER_ANCHOR} size="lg" data-id="element-106" data-mp="x0uw65cy670o">
            🚀 Sí, quiero comenzar ahora
          </CtaButton>
          <p className="mt-2.5 text-xs font-semibold text-muted" data-id="element-107" data-mp="3lquffqlsob64">
            Acceso Digital Inmediato • Garantía de 7 Días
          </p>
        </div>
      </div>
    </header>;
}